import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "col-md-4 col-lg-12" }
const _hoisted_7 = { class: "col-md-4 col-lg-12" }
const _hoisted_8 = { class: "col-md-4 col-lg-12" }
const _hoisted_9 = { class: "row justify-content-center" }
const _hoisted_10 = { class: "col-lg-5" }
const _hoisted_11 = { class: "col-lg-7" }
const _hoisted_12 = { class: "row justify-content-center" }
const _hoisted_13 = { class: "col-xl-7 col-xxl-8 col-lg-7" }
const _hoisted_14 = { class: "col-xl-5 col-xxl-4 col-lg-5" }
const _hoisted_15 = { class: "row justify-content-center" }
const _hoisted_16 = { class: "col-xl-5 col-xxl-4 col-lg-5" }
const _hoisted_17 = { class: "col-xl-7 col-xxl-8 col-lg-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeDashboard = _resolveComponent("WelcomeDashboard")!
  const _component_TotalSalesChart = _resolveComponent("TotalSalesChart")!
  const _component_TotalOrdersChart = _resolveComponent("TotalOrdersChart")!
  const _component_TotalCustomersChart = _resolveComponent("TotalCustomersChart")!
  const _component_TotalRevenueChart = _resolveComponent("TotalRevenueChart")!
  const _component_SalesByLocations = _resolveComponent("SalesByLocations")!
  const _component_TopSellingProducts = _resolveComponent("TopSellingProducts")!
  const _component_RecentOrders = _resolveComponent("RecentOrders")!
  const _component_OrderSummaryChart = _resolveComponent("OrderSummaryChart")!
  const _component_RecentTransactions = _resolveComponent("RecentTransactions")!
  const _component_ReturningCustomerRateChart = _resolveComponent("ReturningCustomerRateChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_WelcomeDashboard),
        _createVNode(_component_TotalSalesChart)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_TotalOrdersChart)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TotalCustomersChart)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_TotalRevenueChart)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_SalesByLocations)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_TopSellingProducts)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_RecentOrders)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_OrderSummaryChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_RecentTransactions)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_ReturningCustomerRateChart)
      ])
    ])
  ]))
}